import { CloseOutlined } from '@ant-design/icons';
import { Tag } from 'antd';
import cn from 'classnames';
import { FC } from 'react';

import styles from '../styles.module.scss';

interface IFilterChipProps {
  fieldLabel: string;
  displayValue: string;
  onRemove: () => void;
  className?: string;
}

const FilterChip: FC<IFilterChipProps> = ({
  fieldLabel,
  displayValue,
  onRemove,
  className,
}) => {
  return (
    <Tag
      className={cn(styles.chip, className)}
      closable
      closeIcon={<CloseOutlined className={styles.closeIcon} />}
      onClose={(e) => {
        e.preventDefault();
        onRemove();
      }}
    >
      <span className={styles.chipLabel}>{fieldLabel}:</span>
      <span className={styles.chipValue}>{displayValue}</span>
    </Tag>
  );
};

export default FilterChip;
